export class Well {
    constructor() { }
    public wellID: number | null = null; //will be blank for new entry
    public batteryID: number | null = null;
    public Alias: String | null = null;
    public WellboreID: number | null = null;
    public gasFacilityID: number | null = null;
    public notes: string | null = null;
    public statusID: number | null = null;
    public leaseNumber: string | null = null;
    public serialNumber: string | null = null;
    public reservoirName: string | null = null;
    public apiNumber: string | null = null;
    public perfSetID : number | null = null;
    public totalVerticalDepth: number | null = null;
    public measuredDepth: number | null = null;
    public subSeaDepth: number | null = null;
    public referenceElevation: number | null = null;
    public wellName: string | null = null;
    public operatorName: string = "";
    public nrioil: number | null = null;
    public nrigas: number | null = null;
    public nwioil: number | null = null;
    public nwigas: number | null = null;
    public insuranceConverage: number | null = null;
    public regWellTypeID: number | null = null;
    public regFieldName: string | null = null;
    public regOperCode: string | null = null;
    public regState: string | null = null;
    public regCounty: string | null = null;
    public regDistrict: string | null = null;
    public regCommPermit :string | null = null;
    public regDrillPermit: string | null = null;
    public isOperated: boolean | null = null;
    public swdMaxPSI: number | null = null;
    public swdMaxRate: number | null = null;
    public skimTankID: number | null = null;
    public regLeaseName: string | null = null;
    public regWellNumber: string | null = null;
    public mmbtUperMCF: number | null = null;
    public swdIntervalTop: number | null = null;
    public swdIntervalBottom: number | null = null;
    public gasInPlateSize: number | null = null;
    public gasInMeterDiameter: number | null = null;
    public gasInSpringSize: number | null = null;
    public gasInisPercentageChart: boolean | null = null;
    public gasInisSquareRootChart: number | null = null;
    public gasInPlateCoefficient: number | null = null;
    public gasOutPlateSize: number | null = null;
    public gasOutMeterDiameter: number | null = null;
    public gasOutSpringSize: number | null = null;
    public gasOutisPercentageChart: boolean | null = null;
    public gasOutisSquareRootChart: boolean | null = null;
    public gasOutPlateCoefficient: number | null = null;
    public plugBackDepth: number | null = null;
    public swdid: number | null = null;
    public swdMaxVolume: number | null = null;
    public isGasCalculated: boolean | null = null;
    public isGasAllocatedDaily: boolean | null = null;
    public isOilAllocatedDaily: boolean | null = null;
    public isWaterAllocatedDaily: number | null = null;
    public cF_DailyProdSP: string | null = null;
    public pumpbore: number | null = null;
    public hasFluidMeter: boolean | null = null;
    public regWellStatus: string | null = null;
    public regFieldCode: string | null = null;
    public regParishCode: string | null = null;
    public regSection: string | null = null;
    public regTownship: string | null = null;
    public regRange: string | null = null;
    public regPool: string | null = null;
    public regClass: string | null = null;
    public regSubClass: string | null = null;
    public regMeridian: string | null = null;
    public regFacilityCode: string | null = null;
    public regTransporterCode: string | null = null;
    public landPropertyID: number | null = null;
    public isUnitized: boolean | null = null;
    public landUnitFK: number | null = null;
    public landLeaseFK: number | null = null;
    public injectionMethodID: number | null = null;
    public packerDepth: number | null = null;
    public isIntermittentWell: boolean | null = null;
    public directionalFlag: string | null = null;
    public valve1PSC: number | null = null;
    public wellLandWaterTypeID: number | null = null;
    public wellSingleDualTypeID: number | null = null;


        //---- Wells properties
     //   private int? WellID { get; set; } //will be blank because new entry
    public sortOrder: number | null = null;
    public injectionWell: boolean | null = null;
    public masip: number | null = null;
    public fieldID: number | null = null;
    public lat: number | null = null;
    public lon: number | null = null;
    public isGasLiftWell: number | null = null;
    public xcoord: number | null = null;
    public ycoord: number | null = null;
}
